import Header from '@/components/ui/header';
import { useApp } from '@/context/AppContext';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { AddNiche } from '@/components/dashboard/AddNiche';
import { Card, CardContent } from '@/components/ui/card';
import { DeleteNiche } from '@/components/dashboard/DeleteNiche';
import { cn } from '@/lib/utils';
import { useEffect } from 'react';
import { ChartData } from '@/components/dashboard/Chart/ChartData';
import { Config } from '@/types';

import { serviceUpdateConfig } from '@/services/configs';
import Configs from '@/components/dashboard/Configs';
import { toast } from '@/components/ui/use-toast';
import Footer from '@/components/ui/footer';

const Dashboard = () => {
  const { listTypeNiche, updateListTypeEvent, listTypeEvent, callApis, configs } = useApp();

  const handleToggleCheckbox = (id: number) => {
    updateListTypeEvent(id);
  };

  const handleSave = async (config: Config) => {
    // Aqui você chama a API para salvar as configurações
    try {
      await serviceUpdateConfig(config);
      await callApis();
      toast({
        title: 'Configuração salva com sucesso!',
        variant: 'default',
      });
    } catch (error) {
      toast({
        title: 'Erro ao salvar a configuração.',
        description: error?.message || 'Ocorreu um erro ao salvar a configuração. Tente novamente.',
        variant: 'destructive',
      });
    }
  };

  useEffect(() => {
    if (listTypeEvent.length === 0 && listTypeNiche.length === 0) {
      callApis();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-secondary to-background">
      <Header />

      <main className="container mx-auto px-4 py-8">
        <div className="max-w-5xl mx-auto space-y-8">
          <ChartData />
          <h2 className="text-2xl font-bold mb-6">Configurações</h2>

          <div className="mt-10 opacity-80 flex-row gap-4 grid grid-cols-2">
            <Card className="flex-1">
              <CardContent>
                <h3 className="text-lg font-bold mb-7 mt-4">Tipo de Eventos</h3>

                <div className="flex flex-col gap-2 mb-5">
                  {listTypeEvent.map((ev) => (
                    <div key={ev.id} className="flex items-center gap-3">
                      <Checkbox
                        id={String(ev.id)}
                        checked={ev.active}
                        onCheckedChange={() => handleToggleCheckbox(ev.id)}
                      />
                      <Label htmlFor={ev.name}>{ev.name}</Label>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>

            <Card className="flex-1">
              <CardContent>
                <h3 className="text-lg font-bold mb-7 mt-4">Nichos Cadastrados</h3>
                <div className="flex flex-wrap gap-5 mb-5">
                  {listTypeNiche.map((item) => {
                    const isCustom = item.name === 'Custom';

                    return (
                      <div key={item.id} className="flex items-center">
                        <span
                          key={item.id}
                          className={cn(
                            'bg-primary text-white px-3 py-1 rounded-l text-xs font-mono border border-secondary',
                            isCustom ? 'rounded-r' : '',
                          )}
                        >
                          {item.name}
                        </span>
                        {!isCustom && <DeleteNiche id={item.id} />}
                      </div>
                    );
                  })}
                </div>
                <div className="items-center justify-center flex">
                  <AddNiche />
                </div>
              </CardContent>
            </Card>

            <Configs configs={configs} handleSave={handleSave} />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Dashboard;
